import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { useQueryClient } from '@tanstack/react-query';

import { MY_GROUPS_KEY } from '@/constants/queryKeys';

/**
 * circle-activity-order — the circle list is ordered by latest activity, and a
 * sound can land while the app is in the background without any push (circle
 * muted, track already heard). Coming back to the app reloads the circle list —
 * and only it: invalidating the feed would reshuffle the deck under the finger.
 * `@capacitor/app` maps `resume` to `visibilitychange` on the web.
 */
export function useRefreshCirclesOnResume() {
  const queryClient = useQueryClient();
  useEffect(() => {
    const handle = App.addListener('resume', () => {
      void queryClient.invalidateQueries({ queryKey: MY_GROUPS_KEY });
    });
    return () => {
      void handle.then((h) => h.remove());
    };
  }, [queryClient]);
}
